
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, } from 'react-bootstrap';
import { productClassOperations, productClassSelectors } from "./state";
import { PRODUCTCLASS } from "./routes";
import FormTemplate from '../../components/FormTemplate';
import ModuleHeader from '../../components/ModuleHeader';
import { MAX_INT, PRODUCTCLASS_CODE, MODE_EDIT, MODE_ADD, ERROR, EMPTY_COUNT, EMPTY_STRING, KANA_NO, KANA_YES, REGEX_NUMERIC } from '../../../utils/constants';
import { ERROR_PRODUCT_CLASS_NOT_EXIST, ERROR_PRODUCT_CLASS_RETRIEVE, CONFIRMATION_DELETE, ERROR_PRODCLASS_CREATE, ERROR_PRODCLASS_UPDATE, ERROR_PRODCLASS_DELETE } from '../../../utils/messages';
import ErrorAlert from '../../components/ErrorAlert';
import Confirmation from '../../components/Confirmation';

class ViewProductClass extends Component {
    constructor(props) {
        super(props)
        this.state = {
            promptDelete: false,
            invalidProductClass: false,
            productClassCode: EMPTY_STRING,
            productClassName: EMPTY_STRING,
            copy: this.props.location.state && this.props.location.state.copy,
            error: []
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount() {
        let id = this.props.match.params.id;

        if (undefined === id) {
            this.setState({ mode: MODE_ADD });
        } else {
            if (!this.state.copy) {
                this.setState({ mode: MODE_EDIT })
            }
            
            this.props.view(id).then((result) => {
                if (null === result.data) {
                    this.setState({ error: [ERROR_PRODUCT_CLASS_NOT_EXIST], invalidProductClass: true });
                } else {
                    let productClass = result.data
                    this.setState({
                        productClassName: productClass.productClassName
                    });

                    if (!this.state.copy) {
                        this.setState({
                            productClassCode: productClass.productClassCode
                        });
                    }
                }
            }).catch(() => {
                this.setState({ error: [ERROR_PRODUCT_CLASS_RETRIEVE], invalidProductClass: true });
            });
        }
    }

    handleInputChange = (event) => {
        if ((PRODUCTCLASS_CODE === event.target.name
            && MAX_INT > event.target.value
            && MODE_EDIT !== this.state.mode
            && event.target.value.match(REGEX_NUMERIC))
            || PRODUCTCLASS_CODE !== event.target.name) {
            this.setState({ [event.target.name]: event.target.value });
        }

    }

    handleSubmit = () => {

        let errorList = productClassSelectors.validate(this.state);

        if (EMPTY_COUNT < errorList.length) {
            if (!this.state.invalidProductClass) {
                this.setState({ error: errorList });
            }
        } else {
            let productClass = {
                productClassCode: this.state.productClassCode,
                productClassName: this.state.productClassName.trim(),
                userCode: this.props.user.user_cd
            };

            if (MODE_EDIT === this.state.mode) {
                this.props.editProductClass(productClass).then((result) => {
                    if (ERROR === result.status) {
                        this.setState({ error: [result.message] });
                    } else {
                        this.showList();
                    }
                }).catch(() => this.setState({ error: [ERROR_PRODCLASS_UPDATE] }));
            } else {
                this.props.addProductClass(productClass).then((result) => {
                    if (ERROR === result.status) {
                        this.setState({ error: [result.message] });
                    } else {
                        this.showList();
                    }
                }).catch(() => this.setState({ error: [ERROR_PRODCLASS_CREATE] }));
            }
        }
    }

    showList = () => {
        this.props.history.push(PRODUCTCLASS);
    }

    delete = () => {
        this.setState({ promptDelete: false })
        if (!this.state.invalidProductClass) {
            this.props.deleteProductClass(this.state.productClassCode).then((result) => {
                if (ERROR === result.status) {
                    this.setState({ error: [result.message] });
                } else {
                    this.showList();
                }
            }).catch(() => this.setState({ error: [ERROR_PRODCLASS_DELETE] }));
        }
    }

    render() {
        return (
            <Grid fluid={true}>
                <Grid>
                    <ModuleHeader title={"商品分類編集"} />

                    <ErrorAlert errors={this.state.error} />


                        <FormTemplate
                            {...this.props}
                            {...this.state}
                            className="product-form"
                            horizontal={true}
                            editMode={MODE_EDIT === this.state.mode}
                            handleSubmit={this.handleSubmit}
                            handleInputChange={this.handleInputChange}
                            formButtons={[
                                { label: "登録", onClick: () => this.handleSubmit() },
                                { label: "削除", conditional: true, onClick: () => this.setState({promptDelete:true})  },
                                { label: "戻る", onClick: () => this.showList() }
                            ]}
                        />

                    <Confirmation
                        message={CONFIRMATION_DELETE}
                        showConfirmation={this.state.promptDelete}
                        buttons={[
                            { label: KANA_YES, action: () => { this.delete() } },
                            { label: KANA_NO, action: () => { this.setState({ promptDelete: false }) } }
                        ]}
                    />
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.auth.credentials,
        tableList: state.productClass.list,
        formInputs: state.productClass.form
    }
};
const mapDispatchToProps = {
    view: productClassOperations.viewProductClass,
    addProductClass: productClassOperations.addProductClass,
    editProductClass: productClassOperations.editProductClass,
    deleteProductClass: productClassOperations.deleteProductClass,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewProductClass);